import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Componentes globales
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Páginas principales (en el paquete inicial)
import Home from './pages/Home';
import Historia from './pages/Historia';
import Servicios from './pages/Servicios';
import Contacto from './pages/Contacto';
import NoEncontrada from './pages/NoEncontrada';

import './App.css';

// Páginas más pesadas o menos visitadas: se cargan bajo demanda
const CalculadoraAlmacenaje = lazy(() => import('./pages/CalculadoraAlmacenaje'));
const TrabajosRealizados = lazy(() => import('./pages/TrabajosRealizados'));
const Albaranes = lazy(() => import('./pages/Albaranes'));

// Legal
const AvisoLegal = lazy(() => import('./pages/Legal/AvisoLegal'));
const PoliticaPrivacidad = lazy(() => import('./pages/Legal/PoliticaPrivacidad'));

// Páginas de uso interno que se muestran sin cabecera, menú ni pie
const RUTAS_SIN_MARCO = ['/albaranes'];

function Cargando() {
    return (
        <div className="cargando-pagina" role="status">
            Cargando…
        </div>
    );
}

function Layout() {
    const { pathname } = useLocation();
    const rutas = (
        <Suspense fallback={<Cargando />}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/historia" element={<Historia />} />
                <Route path="/servicios" element={<Servicios />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/aviso-legal" element={<AvisoLegal />} />
                <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
                <Route path="/calculadora-almacenaje" element={<CalculadoraAlmacenaje />} />
                <Route path="/trabajos-realizados" element={<TrabajosRealizados />} />
                <Route path="/albaranes" element={<Albaranes />} />
                <Route path="*" element={<NoEncontrada />} />
            </Routes>
        </Suspense>
    );

    if (RUTAS_SIN_MARCO.includes(pathname.replace(/\/+$/, ''))) return rutas;

    return (
        <div className="layout">
            <Navbar />
            <main className="main-content">{rutas}</main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <Router>
            <Layout />
        </Router>
    );
}

export default App;
